import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import {
  makeStyles,
  Button,
  Title2 as Title,
  Subtitle2 as Subtitle
} from '@fluentui/react-components';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { loginRequest } from '../authConfig';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'white',
    color: 'grey',
    width: '100vw',
    height: '100vh',
    padding: '0 20px',
  },
  btn: {
    marginTop: '20px'
  }
});

function Home() {
  const {instance} = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();
  const styles = useStyles();
  const [isDisabled, setIsDisabled] = useState(false);

  const handleLogin = () => {
    setIsDisabled(true);
    instance
      .loginRedirect(loginRequest)
      .catch(e => console.error(e))
      .finally(() => setIsDisabled(false));
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/report');
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className={styles.root}>
      <Title>Bienvenue sur le Tableau de Bord BSTM</Title>
      <Subtitle>Veuillez vous connecter pour un accès sécuritaire.</Subtitle>
      <Button
        className={styles.btn}
        appearance="primary"
        onClick={handleLogin}
        disabled={isDisabled}
      >
        Se connecter
      </Button>
    </div>
  );
}

export default Home;
